import appConfig from "../app.config"
import vuexStoreFactory from "@/_util/vuex-store-factory"
let factory = new vuexStoreFactory();
var mixin = factory.generateVuexNamespacedMixin(appConfig.store, appConfig.namespace);

export default {
    computed : {
        ...mixin.computed,
        settings(){
            return appConfig.settings || {}
        }
    }
}
